<template>
<svg xmlns="http://www.w3.org/2000/svg" width="14.25" height="14.25" viewBox="0 0 14.25 14.25">
  <g>
    <path d="M9.87 6.141c-.727 1.084-3.226 4.617-4.879 4.617C3.345 10.75.846 7.223.12 6.141a.7.7 0 0 1 .192-.978.706.706 0 0 1 .977.193 19.208 19.208 0 0 0 3 3.577V.7A.7.7 0 1 1 5.7.7v8.236a19.1 19.1 0 0 0 3-3.579.7.7 0 0 1 1.17.785z" transform="rotate(-90 6.956 5.067)" fill="currentColor"/>
  </g>
</svg>
</template>
